import { useState, useEffect, useRef } from "react";
import "./search-activities.scss";
import TransparentFilter from "./Filters/Transparent/TransparentFilter";
import ActivitiesFilter from "./Filters/Activities/ActivitiesFilter";
import ActivitiesResults from "./ActivitiesResults";
import ActivitiesCard from "./ActivitiesCard";
import ActivityDetail from "./MoreInfoCard/ActivityDetail";
import { ActivitiesContext } from "./context/activities-context";
import { useDebouncedEffect } from "./hooks/useDebouncedEffect ";

export const SearchActivities = (props) => {
	
	const [activities, setActivities] = useState([]);
	const [activitiesCards, setActivitiesCards] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [isLoadingMore, setIsLoadingMore] = useState(false);
	const [isLoadingDictionary, setIsLoadingDictionary] = useState(false);
	const [moreInfoVisible, setMoreInfoVisible] = useState(false);
	const [moreInfoCard, setMoreInfoCard] = useState(null);

	const limit = useRef(12);
	const [startCard, setStartCard] = useState(0);

	const [ageFilter, setAgeFilter] = useState("");
	const [ageButtonActive, setAgeButtonActive] = useState(false);
	const [ageButtonId, setAgeButtonId] = useState("");

	const [activityFilter, setActivityFilter] = useState("");
	const [activityButtonActive, setActivityButtonActive] = useState(false);
	const [activityButtonId, setActivityButtonId] = useState("");

	const [extraButtonActive, setExtraButtonActive] = useState(false);
	const [extraButtonId, setExtraButtonId] = useState("");

	const [branchButtonActive, setBranchButtonActive] = useState(false);
	const [branchButtonId, setBranchButtonId] = useState("");

	const [searchFilter, setSearchFilter] = useState("*.*");
	const searchInputRef = useRef("");

	const [dateFilter, setDateFilter] = useState("");
	const [dateButtonActive, setDateButtonActive] = useState(false);
	const [dateButtonId, setDateButtonId] = useState("");

	const [locations, setLocations] = useState([]);
	const [locationFilter, setLocationFilter] = useState("");
	const [locationButtonId, setLocationButtonId] = useState("");
	const [locationButtonText, setLocationButtonText] = useState("");
	const [locationQuery, setLocationQuery] = useState("");
	const [distanceQuery, setDistanceQuery] = useState("");
	const [toggleActive, setToggleActive] = useState(false);

	const [distanceFilter, setDistanceFilter] = useState("");
	const [distanceButtonId, setDistanceButtonId] = useState("");

	const [sportTypeFilter, setSportTypeFilter] = useState("");
	const [checked, setChecked] = useState([false, false, false]);
	const [sportTypeId, setSportTypeId] = useState("");
	const [sportTypeString, setSportTypeString] = useState("");

	const [dictionaryWords, setDictionaryWords] = useState([]);
	const [OpenInitial , setOpenInitial] = useState(false);
	const controllerRef = useRef(null);

	// Retrieve dictionary words
	// Local
	//const dictionaryUrl = "https://localhost:44360/umbraco/api/activities/getfichedictionaries";
	// Build
	const dictionaryUrl = "/umbraco/api/activities/getfichedictionaries";

	useEffect(() => {
		setDictionaryWords(props.dict);
	}, []);

	// Retrieve cities data
	// Local
	//const locationsUrl = "https://localhost:44360/umbraco/api/activities/getcities/";
	// Build
	const locationsUrl = "/umbraco/api/activities/getcities/";

	async function fetchCities() {
		try {
			const response = await fetch(locationsUrl);

			if (!response.ok) {
				throw new Error("Something went wrong...");
			}

			const data = await response.json();

			return setLocations(data);
		} catch (error) {
			console.log(error);
		}
	}

	useEffect(() => {
		fetchCities();
	}, []);

	// Retrieve activities data
	// Local
	//const apiUrl = "https://localhost:44360/umbraco/api/activities/search/";
	// Build
	const apiUrl = "/umbraco/api/activities/search/";

	const resetValues = () => {
		setActivitiesCards([]);
		setStartCard(0);
	}

	async function fetchActivities() {
		if(!isLoadingMore){
			resetValues();
			setIsLoading(true);
		}

		if (controllerRef.current) {
			controllerRef.current.abort();
		}

		const controller = new AbortController();
		controllerRef.current = controller;

		const base = '(terms.label:"Actie en avontuur" OR terms.label:"Moderne dans" OR terms.label:"Volksdans en werelddans" OR terms.label:"Fitness, gymnastiek, dans en vechtsport" OR terms.label:"Dance" OR terms.label:"Circus" OR terms.label:"Stijl en salondansen" OR terms.label:"Omnisport en andere" OR terms.label:"Ballet en klassieke dans" OR terms.label:"Atletiek, wandelen en fietsen" OR terms.label:"Zwemmen en watersport" OR terms.label:"Outdoor en adventure" OR terms.label:"Bal en racketsport")';
		const noFilters = `AND (terms.label:"Kamp of vakantie" OR terms.label:"Sportactiviteit" OR terms.label:"Fiets- of wandelroute" OR (${base} AND terms.label:"Beurs") OR (${base} AND terms.label:"Lezing of Congres") OR (${base} AND terms.label:"Cursus of Workshop"))`

		try {
			var query = JSON.stringify(
				activityFilter.length === 0 && sportTypeFilter.length === 0 ? {
					query: `?q=${searchFilter} AND (NOT labels:nosportvlaanderen) ${noFilters} ${
					!distanceFilter ? locationFilter : ""
					  } ${ageFilter}&sort[availableTo]=asc&start=${startCard}&limit=${limit.current}${dateFilter}${distanceFilter}`,
				} : {
					query: `?q=${searchFilter} AND (NOT labels:nosportvlaanderen) ${sportTypeFilter} ${activityFilter} ${
						!distanceFilter ? locationFilter : ""
					} ${ageFilter}&sort[availableTo]=asc&start=${startCard}&limit=${
						limit.current
					}${dateFilter}${distanceFilter}`,
				}
			);

			const response = await fetch(apiUrl, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: query,
				signal: controllerRef.current?.signal,
			});

			if (!response.ok) {
				throw new Error("Something went wrong...");
			}

			controllerRef.current = null;
			const data = await response.json();

			setIsLoading(false);
			setIsLoadingMore(false);
			setToggleActive(false);

			setLocationQuery(locationQuery);
			setDistanceQuery(distanceQuery);

			return setActivities(data);
		} catch (error) {
			setIsLoading(false);
			setIsLoadingMore(false);
			setToggleActive(false);
			console.log(error);
		}
	}

	async function fetchSpecified() {
		setIsLoading(true);

		const base = '(terms.label:"Actie en avontuur" OR terms.label:"Moderne dans" OR terms.label:"Volksdans en werelddans" OR terms.label:"Fitness, gymnastiek, dans en vechtsport" OR terms.label:"Dance" OR terms.label:"Circus" OR terms.label:"Stijl en salondansen" OR terms.label:"Omnisport en andere" OR terms.label:"Ballet en klassieke dans" OR terms.label:"Atletiek, wandelen en fietsen" OR terms.label:"Zwemmen en watersport" OR terms.label:"Outdoor en adventure" OR terms.label:"Bal en racketsport")';
		const noFilters = `AND (terms.label:"Kamp of vakantie" OR terms.label:"Sportactiviteit" OR terms.label:"Fiets- of wandelroute" OR (${base} AND terms.label:"Beurs") OR (${base} AND terms.label:"Lezing of Congres") OR (${base} AND terms.label:"Cursus of Workshop"))`

		var holderSpecificFiche = {}
		try {
			const querySpecifiedFromUrl = JSON.stringify({query: `?q=id:${props.id}`});
			await fetch(apiUrl, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: querySpecifiedFromUrl,
			}).then(async (response) => {
				await response.json()
					.then(async (data) => {
						holderSpecificFiche = { data };

						const query = JSON.stringify({query: `?q=${searchFilter} AND (NOT labels:nosportvlaanderen) ${noFilters} ${
							!distanceFilter ? locationFilter : ""
							} ${ageFilter}&sort[availableTo]=asc&start=${startCard}&limit=${limit.current - 1}${dateFilter}${distanceFilter}`}) 
							
							await fetch(apiUrl, {
								method: "POST",
								headers: { "Content-Type": "application/json" },
								body: query,
							}).then(async (response) => {
								await response.json()
									.then(async (data) => {
										setIsLoading(false);
										setToggleActive(false);
										setLocationQuery(locationQuery);
										setDistanceQuery(distanceQuery);
										data.member.push(holderSpecificFiche.data.member[0])

										return setActivities(data);
									})
							}).catch(error => {
								throw new Error("Something went wrong2...");
							})
					})
			})
			.catch(error => {
				throw new Error("Something went wrong...");
			})

		} catch (error) {
			setIsLoading(false);
			setToggleActive(false);
			console.log(error);
		}
	}

	// Fetch API data on first render
	useEffect(() => {
		if (props.id) {
			fetchSpecified();
		}
		else{
			fetchActivities();
		}
	}, []);

	// Avoid unnecessary API calls from rapid filter changes by user
	useDebouncedEffect(
		() => {
			fetchActivities(
				startCard,
				ageFilter,
				activityFilter,
				searchFilter,
				dateFilter,
				locationFilter,
				distanceFilter,
				sportTypeFilter,
				locationQuery
			);
		},
		[
			startCard,
			ageFilter,
			activityFilter,
			searchFilter,
			dateFilter,
			locationFilter,
			distanceFilter,
			sportTypeFilter,
			locationQuery,
		],
		800
	);

	useEffect(() => {
		if (activities.member) {
			const newActivities = [];
			var open = false;
			if(!OpenInitial){
				activities.member.forEach((activity) => {
					if(activity){
						if(props.id && activity['@id'].includes(props.id)){
							open = true;
						}
						else{
							open = false;
						}
						newActivities.push(
							<ActivitiesCard
								key={activity.sameAs[0]}
								activity={activity}
								open={open}
							/>);
					}
				})
					
				setOpenInitial(true);
			}
			else{
				activities.member.forEach((activity) => {
					newActivities.push(
						<ActivitiesCard
							key={activity.sameAs[0]}
							activity={activity}
							open={false}
						/>);
				})

			}
			setActivitiesCards([...activitiesCards, newActivities]);
		}
	}, [JSON.stringify(activities.member), activities]);

	const onLoadMore = () => {
		setStartCard((prevState) => prevState + limit.current);
		setIsLoadingMore(true);
	};	

	const setAgeString = (str) => {
		setStartCard(0);
		setAgeFilter(str);
	};

	const setActivityString = (str) => {
		setStartCard(0);
		setActivityFilter(str);
	};

	const setSearchString = (str) => {
		setStartCard(0);
		if (str === "") {
			setSearchFilter("*.*");
		} else {
			setSearchFilter(str);
		}
	};

	const setDateString = (str) => {
		setStartCard(0);
		setDateFilter(str);
	};

	const setLocationString = (str) => {
		setStartCard(0);
		setLocationFilter(str);
	};

	const setDistanceString = (str) => {
		setStartCard(0);
		setDistanceFilter(str);
	};

	const setSportTypes = (sportTypeString) => {
		if (
			checked[0] === false &&
			checked[1] === false &&
			checked[2] === false
		) {
			setSportTypeFilter("");
		} else {
			setSportTypeFilter(sportTypeString);
		}
	};

	useEffect(() => {
		setSportTypes(sportTypeString, checked);
	}, [sportTypeString, checked]);

	const scrollRef = useRef(null);
	const executeScroll = () => {
		scrollRef.current.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest"});
	}

	return (
		// Use the <ActivitiesContext.Provider> wrapper where you want to use global state
		// Define global state by passing the Provider a value
		<ActivitiesContext.Provider
			value={{
				activities,
				activitiesCards,
				isLoading,
				isLoadingMore,
				isLoadingDictionary,
				moreInfoVisible,
				setMoreInfoVisible,
				moreInfoCard,
				setMoreInfoCard,
				startCard,
				limit,

				ageButtonActive,
				setAgeButtonActive,
				ageButtonId,
				setAgeButtonId,
				setAgeString,

				activityButtonActive,
				setActivityButtonActive,
				activityButtonId,
				setActivityButtonId,
				extraButtonActive,
				setExtraButtonActive,
				extraButtonId,
				setExtraButtonId,
				branchButtonActive,
				setBranchButtonActive,
				branchButtonId,
				setBranchButtonId,
				setActivityString,

				searchInputRef,
				setSearchString,

				dateButtonActive,
				setDateButtonActive,
				dateButtonId,
				setDateButtonId,
				setDateString,

				locations,
				setLocations,
				locationButtonId,
				setLocationButtonId,
				locationButtonText,
				setLocationButtonText,
				setLocationString,
				locationQuery,
				setLocationQuery,
				distanceQuery,
				setDistanceQuery,
				toggleActive,
				setToggleActive,

				distanceButtonId,
				setDistanceButtonId,
				setDistanceString,

				fetchActivities,
				executeScroll,

				checked,
				setChecked,
				sportTypeId,
				setSportTypeId,
				sportTypeString,
				setSportTypeString,
				setSportTypes,

				dictionaryWords,
				setDictionaryWords,
			}}
		>
			<section
				className={`o-page__main o-search__main u-clear ${props.bottomSpacing ? props.bottomSpacing : ""}`}
				role="main"
				id="main"
			>
				<header className="c-section__header">
							<h2 className="title" ref={scrollRef}>
								{!isLoadingDictionary && (
									<>
										{activities && activities.totalItems}
										<span>{` ${dictionaryWords?.activities}`}</span>
									</>
								)}
							</h2>
						</header>
				<TransparentFilter />

				<div
					className="c-section-wrap c-section-index full-width c-activity-from-query c-activity__wrap"
					id="resultaten"
				>
					<div
						className="c-section c-section--fiche c-search"
					>
						<div className="c-section__body">
							<div className="activities u-clear">
								<ActivitiesFilter />
								<ActivitiesResults loadMore={onLoadMore} />
							</div>
						</div>
					</div>
				</div>
			</section>
			{moreInfoVisible && <ActivityDetail moreInfoCard={moreInfoCard} />}
		</ActivitiesContext.Provider>
	);
};
